import React, { Component } from "react";
import {autorun} from 'mobx';
import { inject, observer } from "mobx-react";
import { compose } from "recompose";
import { withRouter, Link } from "react-router-dom";
import { withAuthorization, createUser } from "./utils/auth";
import {db} from './firebase/firebase';

import {
  Form,
  Spin,
  Button,
  Input,
  Tag,
  Icon,
  Divider,
  Avatar,
  Rate,
  List
} from "antd";

import ContractForm from "./ContractForm";
import Requests from './Requests';

import { Document, Collection } from "firestorter";
import moment from 'moment';
import 'moment/locale/fr';
moment.locale('fr');

const FormItem = Form.Item;
@observer
class ContractDetails extends Component {
  constructor(props) {
    super(props);
    this.state = {
      contract: this.props.location.data ? this.props.location.data.contract : null,
      loading: null,
      isReadOnly: true
    };

    this.updateRequest = this.updateRequest.bind(this);
    this.doDelete = this.doDelete.bind(this)
    this.switchEdit = this.switchEdit.bind(this);
    this.dispose = undefined;
    console.log("requestDetails props", this.props);
  }

  componentDidMount() {
    if (this.state.contract == null) {
      this.setState({loading: true});
      db.collection("contracts").doc(this.props.match.params.id).get().then((querySnapshot) => {
        if(querySnapshot.exists){
          console.log(querySnapshot);
          this.setState({ contract: querySnapshot.data() });
          this.setState({loading: false});
          db.collection("requests").where('contractId', '==', this.props.match.params.id).get().then((requests) => {
            this.setState({requests: requests});
          });
        }
      });


      // this.setState({ loading: false });
    }
  }
  componentWillUnmount(){
    this.setState({contract: null});
  }
  async doDelete() {
    this.setState({ loading: true });
    await db.collection('contracts').doc(this.props.match.params.id).delete();
    this.setState({ loading: false });
    this.props.history.push("/contracts");
  }
  async updateRequest(data) {
    try {
      await this.requestDocument.update(data, { merge: true });
      this.setState({isReadOnly: true});
    } catch (e) {
      throw new Error(e);
    }
  }
  switchEdit() {
    if(!this.state.isReadOnly){
      console.log('REQUEST', this.request)
      this.setState(this.props.request ? {request: {...this.props.request}} : {request: this.request});
      console.log('STATe', this.state.contract);
    }
    this.setState({ isReadOnly: !this.state.isReadOnly });
  }
  async getUser(userId) {
    if(!this.state.users[userId]){
      var userDocument = new Document("users/" + userId, {
        mode: "off"
      });
      const user = await userDocument.fetch();
      if(user.data) {
        return user.data
      } else {
        return false
      }

    }
  }

  render() {
    // const {user} = this.state;
    console.log("re-render");
    const { startTime, startDate, endTime, tasks, nurse, payment, rate, isCancelled, duration } = this.state.contract
      ? this.state.contract
      : "";
    return (
      <div>
        <Spin
          spinning={this.state.loading }
          indicator={<Icon type="loading" style={{ fontSize: 24 }} spin />}
        >
          <div
            style={{
              display: "flex",
              justifyContent: "flex-end",
              alignItems: "baseline",
              position: "absolute",
              right: 0,
              zIndex: 1000
            }}
          >
            <p style={{ margin: 5 }}>Opérations:</p>
          {/*  <Button
              style={{ margin: 5 }}
              type="primary"
              onClick={() => this.switchEdit()}
              loading={
                this.state.loading
              }
            >
              {this.state.isReadOnly ? 'Modifier' : 'Annuler'}
            </Button>*/}

            <Button
              style={{ margin: 5 }}
              type="danger"
              onClick={this.doDelete}
              loading={
                this.state.loading
              }
            >
              Supprimer
            </Button>
          </div>
          <br />
          <Divider orientation="left">
            <div style={{ display: "flex", alignItems: "center", flexDirection: 'Column'}}>
              <h2
                style={{ alignSelf: "center", marginBottom: 0, marginLeft: 15, wordSpacing: '0.2em' }}
              >
                Le {moment(startDate || startTime).format("Do MMMM YYYY")} à {moment(startDate || startTime).format("HH[h]mm")}
              </h2>
              {rate ? <Rate disabled allowHalf defaultValue={Number(rate)} /> : null}
            </div>
          </Divider>
          <br />

            {this.state.contract ? (
            <ContractForm
              disabled={this.state.isReadOnly}
              request={this.state.contract}
              submit={this.updateRequest}
              switchFunc={this.switchEdit}
            />

          ) : null}
          {this.state.requests ? (
          <Requests
            requests={this.state.requests}
            onlyTable={true}
          />

        ) : null}
        </Spin>
      </div>
    );
  }
}

const authCondition = authUser => !!authUser;

export default compose(
  withAuthorization(authCondition),
  inject("userStore"),
  withRouter,
  observer
)(ContractDetails);



// WEBPACK FOOTER //
// ./src/ContractDetails.js